import './Footer.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import replaceVariablesInString from 'utils/replaceVariablesInString';

import DividerIcon from 'components/shared/icons/DividerIcon';
import CommentIcon from 'components/shared/icons/CommentIcon';

class Footer extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    locale: PropTypes.string,
    AA_Give_Feedback_Title: PropTypes.string,
    AA_Give_Feedback_Description: PropTypes.string,
    AA_Start_Survey: PropTypes.string,
    AA_Cookies_Notice: PropTypes.string,
    AA_Contact_Us: PropTypes.string,
    AA_Terms_And_Conditions: PropTypes.string,
    AA_Legal_Notices_Attribution: PropTypes.string,
    AA_Copyright_Notice: PropTypes.string,
  };

  static Constants = {
    SURVEY_URL: 'https://amazon156.qualtrics.com/jfe/form/SV_b7RXR8s7pC9Au8d',
  };

  constructor(props) {
    super(props);
    this.renderFeedback = this.renderFeedback.bind(this);
  }

  renderFeedback() {
    const {
      backgroundColor,
      AA_Give_Feedback_Title,
      AA_Give_Feedback_Description,
      AA_Start_Survey,
    } = this.props;
    return (
      <div className="give-feedback">
        <CommentIcon backgroundColor={backgroundColor} />
        <div className="feedback-title">{AA_Give_Feedback_Title}</div>
        <div className="feedback-description">{AA_Give_Feedback_Description}</div>
        <button
          type="button"
          className="btn btn-default btn-feedback"
          aria-label="Open a new tab to fill out a feedback survey on qualtrics.com"
          onClick={() => { window.open(Footer.Constants.SURVEY_URL); }}
        >
          {AA_Start_Survey}
        </button>
      </div>
    );
  }

  render() {
    const {
      backgroundColor,
      locale,
      AA_Cookies_Notice,
      AA_Contact_Us,
      AA_Terms_And_Conditions,
      AA_Legal_Notices_Attribution,
      AA_Copyright_Notice,
    } = this.props;

    const curDate = new Date();
    const curYear = curDate.getFullYear();

    const feedback = locale != null ? this.renderFeedback() : null;
    let navItemsClassName = 'row nav-items';
    if (feedback) {
      navItemsClassName += ' reduced-margin-top';
    }

    return (
      <footer className="aa-footer">
        <div style={{ backgroundColor }}>
          <div className="container-fluid">
            <div className="aa-footer-divider">
              <DividerIcon backgroundColor={backgroundColor} />
            </div>
            {feedback}
            <div className={navItemsClassName}>
              <div className="col-sm-6 col-sm-push-6">
                <div className="right-nav">
                  <Link to="/help/GND55EH6VPEGMNKR">{AA_Cookies_Notice}</Link>
                  <a data-cy="footer-contact-us" href={`/${locale}/contact`}>{AA_Contact_Us}</a>
                  <Link to="/terms">{AA_Terms_And_Conditions}</Link>
                  <Link to="/terms/legalNotices">{AA_Legal_Notices_Attribution}</Link>
                </div>
              </div>
              <div className="col-sm-6 col-sm-pull-6">
                {replaceVariablesInString(AA_Copyright_Notice, { currentYear: curYear })}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
